import axios from 'axios';

export const fetchDiAccountsByBac = async (bacs = []) => {
    const list = Array.isArray(bacs) ? bacs.map((b) => String(b ?? '').trim()).filter(Boolean) : [];
    if (!list.length) return { byBac: {} };
    const { data } = await axios.post('/api/di/accounts-by-bac', { bacs: list });
    return data;
};

export const fetchDiOrderItemsByReferenceId = async (referenceIds = []) => {
    const list = Array.isArray(referenceIds)
        ? referenceIds.map((v) => String(v ?? '').trim()).filter(Boolean)
        : [];
    if (!list.length) return { byReferenceId: {} };
    const { data } = await axios.post('/api/di/order-items-by-reference-id', { referenceIds: list });
    return data;
};

export const fetchDiOrderItemsLiveByBac = async (bacs = []) => {
    const list = Array.isArray(bacs) ? bacs.map((b) => String(b ?? '').trim()).filter(Boolean) : [];
    if (!list.length) return { byBac: {} };
    const { data } = await axios.post('/api/di/order-items-live-by-bac', { bacs: list });
    return data;
};
